import {
	getBucketId,
	getBucketConfig,
	readBucketConfigFromLocalStorage,
	getBucketConfigOverrides,
} from "@/common/feature-toggling";

export function created() {
	this.onWindowResize();
	if (typeof window.__PRERENDER_INJECTED === "undefined") {
		window.addEventListener("resize", this.onWindowResize);
		window.addEventListener("scroll", this.onWindowScroll);
		this.onWindowScroll();
		this.updateNumberOfLevels({
			minLevel: this.groups[0].min, // first level
			maxLevel: this.groups[this.groups.length - 1].max, // last level
		});

		const currentConfig = readBucketConfigFromLocalStorage();
		if (currentConfig !== null) {
			this.$store.commit(
				"SET_FEATURE_TOGGLE_BUCKET_CONFIG",
				currentConfig
			);
		}

		this.$store.commit(
			"SET_FEATURE_TOGGLE_BUCKET_OVERRIDES",
			getBucketConfigOverrides()
		);
		getBucketConfig()
			.then((config) => {
				this.$store.commit("SET_FEATURE_TOGGLE_BUCKET_CONFIG", config);

				const toggles = config?.toggles || [];

				if (this.$ga) {
					const bucketId = getBucketId();
					const dimensionStr = `${
						bucketId ? `${bucketId}:` : ""
					}${toggles.join(",")}`;
					this.$ga.set("dimension4", dimensionStr);
					this.$ga.set("metric1", bucketId);
				}
			})
			.catch(({ message, data }) => {
				console.error(message, data);
			});
	}
}

export function mounted() {
	window.addEventListener("load", () => {
		if (typeof ADB_D_4j50_o === "undefined") {
			this.$el.classList.add("is-blocking-ads");
		}

		this.detectWebPSupport();
	});
}
